export default __webpack_public_path__ + "static/media/hd6.b1029997.webp";